import { useState, useEffect } from 'react';
import { Globe2, Loader2 } from 'lucide-react';
import { apiCall } from './api';

/** Statistiques d'utilisation par pays (nombre d'abonnés). */
export default function AdminCountryStats({ token }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiCall('/admin/country-stats', 'GET', null, token)
      .then(setRows).catch(() => {}).finally(() => setLoading(false));
  }, [token]);

  const total = rows.reduce((s, r) => s + r.count, 0) || 1;

  if (loading) return <div className="text-center py-6 text-white/50"><Loader2 className="animate-spin mx-auto" size={16} /></div>;

  return (
    <div className="bg-white/5 border border-white/10 rounded-2xl p-4 mb-4" data-testid="admin-country-stats">
      <h3 className="font-bold text-sm mb-3 flex items-center gap-2"><Globe2 size={16} className="text-emerald-400" />Abonnés par pays</h3>
      {rows.length === 0 ? (
        <div className="text-white/40 text-sm">Aucune donnée pour le moment.</div>
      ) : (
        <div className="space-y-2">
          {rows.map(r => (
            <div key={r.country_code || 'none'} data-testid={`country-stat-${r.country_code || 'none'}`}>
              <div className="flex justify-between text-xs mb-0.5"><span>{r.name}</span><span className="text-white/60">{r.count}</span></div>
              <div className="h-2 bg-slate-900 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-emerald-400 to-yellow-400" style={{ width: `${(r.count / total) * 100}%` }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
